import React, { useEffect, useRef, useState } from 'react';
import { DateRangePicker } from 'rsuite';
import 'rsuite/dist/rsuite.css';
import moment from "moment";
import { format } from 'date-fns';
import '../../../common/rsuite-datepicker.css';
import Select, { StylesConfig } from 'react-select';
import fetchAPI from '../../../common/fetchAPI';
import { dropDownSelectionStyles, dateFormatByAccountCulture, normalizeDateFormat, getValueFromResource, dateFormatByAccountCultureForFilters } from '../../../common/timeLiveFunction';
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import {
    getTimeBilingWorksheetForDatatableAsync, setOptionTaskValue, resetSelectedRecordObjectInState,
    setDateRangeValue, setOptionBilledValue, setOptionClientNameValue, setOptionEmployeeNameValue, setOptionProjectValue
} from "./timeBillingSlice";
import DatePickerRanges from '../../../common/DatePickerRanges';

interface DropdownItem {
    value: number;
    label: string;
}

const TimeBillingWorksheetFilter = (props: any) => {
    const { t } = props;
    const { sessionAccountEmployeeId, maxMenuHeight, CurrentCultureDateFormat, cultureInfoName, dateInsertionFormat } = useAppSelector(state => state.globalState);
    const AccountEmployeeId: any = sessionAccountEmployeeId;
    const dispatch = useAppDispatch();
    const { timeBillingWorksheetList, isReload, currentPage, pageSize, isLoading, totalItems, start, recordsFiltered } = useAppSelector((state) => state.timeBillingWorksheet);
    // const [clientNameArray, setClientNameArray] = useState<any | ''>([]);
    const [selectedClientNameOptionDropDown, setSelectedClientNameOptionDropDown] = useState<{ [object: string]: any }>({ value: '0', label: 'All' });
    // const [ProjectArray, setProjectArray] = useState<any | ''>([]);
    const [selectedProjectOptionDropDown, setSelectedProjectOptionDropDown] = useState<{ [object: string]: any }>({ value: '0', label: 'All' });
    // const [TaskArray, setTaskArray] = useState<any | ''>([]);
    const [selectedTaskOptionDropDown, setSelectedTaskOptionDropDown] = useState<{ [object: string]: any }>({ value: '0', label: 'All' });
    const [BilledArray, setBilledArray] = useState<any | ''>([]);
    const [selectedBilledOptionDropDown, setSelectedBilledOptionDropDown] = useState<{ [object: string]: any }>({ value: '-1', label: 'Both' });
    const [clientdata, setClientData] = useState<DropdownItem[]>([{ value: 0, label: 'All' }]);
    const [search, setSearch] = useState<string>('');
    const [page, setPage] = useState(1);
    const [loading, setLoading] = useState(false);
    const [hasMore, setHasMore] = useState(true);
    const [projectdata, setprojectData] = useState<DropdownItem[]>([{ value: 0, label: 'All' }]);
    const [searchProject, setSearchProject] = useState<string>('');
    const [pageProject, setPageproject] = useState(1);
    const [loadingProject, setLoadingProject] = useState(false);
    const [hasMoreProject, setHasMoreProject] = useState(true);
    const [taskdata, setTaskData] = useState<DropdownItem[]>([{ value: 0, label: 'All' }]);
    const [searchTask, setSearchTask] = useState<string>('');
    const [pageTask, setPageTask] = useState(1);
    const [loadingTask, setLoadingTask] = useState(false);
    const [hasMoreTask, setHasMoreTask] = useState(true);
    const currentDate = new Date();
    const [SelectedStartDate, setSelectedStartDate] = useState(() => {
        const newDate = new Date();
        newDate.setMonth(newDate.getMonth() - 2);
        return newDate;
    });
    const [SelectedEndDate, setSelectedEndDate] = useState(currentDate);
    const closeButtonRef = useRef<HTMLButtonElement | null>(null);
    const [displayedRange, setDisplayedRange] = useState('Please Select Date Range');

    useEffect(() => {
        let BilledArray = [
            { value: '-1', label: 'Both' },
            { value: '1', label: 'Billed' },
            { value: '0', label: 'Not Billied' }
        ]
        setBilledArray(BilledArray);
    }, [])

    // useEffect(() => {
    //     fetchCientData(page, search);
    // }, [page, search]);

    useEffect(() => {
        const delayDebounceFn = setTimeout(() => {
            fetchCientData(page, search);
        }, 500);
        return () => clearTimeout(delayDebounceFn);
    }, [page, search]);

    useEffect(() => {
        fetchProjectData(pageProject, searchProject);
    }, [pageProject, searchProject]);

    useEffect(() => {
        fetchTaskData(pageTask, searchTask);
    }, [pageTask, searchTask]);

    const handleClientScroll = (e: React.UIEvent<HTMLDivElement>) => {
        // const bottom = e.currentTarget.scrollHeight - e.currentTarget.scrollTop === e.currentTarget.clientHeight;
        const el = e.currentTarget;
        const bottom = el.scrollHeight - el.scrollTop <= el.clientHeight + 1;
        if (bottom && hasMore && !loading) {
            setPage((prevPage) => prevPage + 1);
        }
    }

    const customMenuListClient = (props: any) => {
        const { children, innerRef, maxHeight, getValue } = props;
        const handleMenuScroll = (e: React.UIEvent<HTMLDivElement>) => {
            handleClientScroll(e);
        }
        return (
            <div onScroll={handleMenuScroll} ref={innerRef} style={{ maxHeight, overflowY: 'auto' }}>
                {children}
            </div>
        );
    }

    const fetchCientData = async (pageNum: any, search: string) => {
        setLoading(true);
        try {
            const searchParam = search ? `&search=${search}` : "";
            const response: any = await fetchAPI(`api/V2/Clients/Dropdown/0?page=${pageNum}${searchParam}`, "GET", "", true);
            const json = await response.json();
            const transformedData = json.items.map((item: any) => ({
                value: item.id,
                label: item.text,
            }));
            const newItems = transformedData.filter((item: any) => !clientdata.some((existingItem: any) => existingItem.value === item.value));
            setClientData((prevData) => [...prevData, ...newItems]);
            setHasMore(newItems.length > 0);
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setLoading(false);
        }
    }

    const handleProjectScroll = (e: React.UIEvent<HTMLDivElement>) => {
        // const bottom = e.currentTarget.scrollHeight - e.currentTarget.scrollTop === e.currentTarget.clientHeight;
        const el = e.currentTarget;
        const bottom = el.scrollHeight - el.scrollTop <= el.clientHeight + 1;
        if (bottom && hasMoreProject && !loadingProject) {
            setPageproject((prevPage) => prevPage + 1);
        }
    }

    const customMenuProjectClient = (props: any) => {
        const { children, innerRef, maxHeight, getValue } = props;
        const handleMenuScroll = (e: React.UIEvent<HTMLDivElement>) => {
            handleProjectScroll(e);
        }
        return (
            <div onScroll={handleMenuScroll} ref={innerRef} style={{ maxHeight, overflowY: 'auto' }}>
                {children}
            </div>
        );
    }

    const fetchProjectData = async (pageNum: any, search: string, AccountClientId: any = 0) => {
        setLoadingProject(true);
        try {
            const searchParam = search ? `&search=${search}` : "";
            const queryParams = new URLSearchParams();
            queryParams.append('AccountEmployeeId', AccountEmployeeId);
            queryParams.append('IsTemplate', 'false');
            queryParams.append('AccountClientId', AccountClientId);
            queryParams.append('page', pageNum);
            queryParams.append('search', search !== undefined && search !== null ? search : "");
            const response: any = await fetchAPI(`api/V2/Projects/NameAndIdByAccountId/0?${queryParams.toString()}`, "GET", "", true);
            const json = await response.json();
            const transformedProjectData = json.Data.items.map((item: any) => ({
                value: item.id,
                label: item.text,
            }));
            const allOption = { value: 0, label: "All" };
            const finalProjectData = [allOption, ...transformedProjectData];
            if (pageNum === 1) {
                setprojectData(finalProjectData);
            } else {
                const newItems = transformedProjectData.filter((item: any) =>
                    !projectdata.some((existingItem: any) => existingItem.value === item.value)
                );
                setprojectData((prevData) => [...prevData, ...newItems]);
            }
            setHasMoreProject(transformedProjectData.length > 0);
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setLoadingProject(false);
        }
    }

    const handleTaskScroll = (e: React.UIEvent<HTMLDivElement>) => {
        // const bottom = e.currentTarget.scrollHeight - e.currentTarget.scrollTop === e.currentTarget.clientHeight;
        const el = e.currentTarget;
        const bottom = el.scrollHeight - el.scrollTop <= el.clientHeight + 1;
        if (bottom && hasMoreTask && !loadingTask) {
            setPageTask((prevPage) => prevPage + 1);
        }
    }

    const customMenuTaskClient = (props: any) => {
        const { children, innerRef, maxHeight } = props;
        const handleMenuScroll = (e: React.UIEvent<HTMLDivElement>) => {
            handleTaskScroll(e);
        }
        return (
            <div onScroll={handleMenuScroll} ref={innerRef} style={{ maxHeight, overflowY: 'auto' }}>
                {children}
            </div>
        );
    }

    const fetchTaskData = async (pageNum: any, search: string, AccountProjectId: any = 0) => {
        setLoadingTask(true);
        try {
            const searchParam = search ? `&search=${search}` : "";
            const queryParams = new URLSearchParams();
            queryParams.append('AccountEmployeeId', AccountEmployeeId);
            queryParams.append('IsTemplate', 'false');
            queryParams.append('AccountProjectId', AccountProjectId);
            queryParams.append('page', pageNum);
            queryParams.append('search', search !== undefined && search !== null ? search : "");
            const response: any = await fetchAPI(`api/V2/Tasks/ProjectTasksForDropdown/0?${queryParams.toString()}`, "GET", "", true);
            const json = await response.json();
            const transformedTaskData = json.Data.items.map((item: any) => ({
                value: item.id,
                label: item.text,
            }));
            const allOption = { value: 0, label: "All" };
            const finalProjectData = [allOption, ...transformedTaskData];
            if (pageNum === 1) {
                setTaskData(finalProjectData);
            } else {
                const newItems = transformedTaskData.filter((item: any) =>
                    !projectdata.some((existingItem: any) => existingItem.value === item.value)
                );
                setprojectData((prevData) => [...prevData, ...newItems]);
            }
            setHasMoreTask(transformedTaskData.length > 0);
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setLoadingTask(false);
        }
    }

    const handleDateRangeChange = (value: any) => {
        // setSelectedStartDate(value[0]);
        // setSelectedEndDate(value[1]);
        // dispatch(setDateRangeValue({ startDate: value[0].toISOString(), endDate: value[1].toISOString() }))
        if (value && value[0] && value[1]) {
            const formattedStartDate = format(value[0], CurrentCultureDateFormat.toString());
            const formattedEndDate = format(value[1], CurrentCultureDateFormat.toString());
            setDisplayedRange(`${formattedStartDate} - ${formattedEndDate}`);
        } else {
            setDisplayedRange('Please Select Date Range');
        }
        // setSelectedStartDate(dateFormatByAccountCulture(value[0].toISOString(), cultureInfoName.toString()));
        // setSelectedEndDate(dateFormatByAccountCulture(value[1].toISOString(), cultureInfoName.toString()));
        // dispatch(setDateRangeValue({ startDate: dateFormatByAccountCulture(value[0].toISOString(), cultureInfoName.toString()), endDate: dateFormatByAccountCulture(value[1].toISOString(), cultureInfoName.toString()) }));
        setSelectedStartDate(dateFormatByAccountCultureForFilters(format(value[0], "yyyy-MM-dd"), cultureInfoName.toString()));
        setSelectedEndDate(dateFormatByAccountCultureForFilters(format(value[1], "yyyy-MM-dd"), cultureInfoName.toString()));
        dispatch(setDateRangeValue({ startDate: format(value[0], "yyyy-MM-dd"), endDate: format(value[1], "yyyy-MM-dd") }));
    }

    const handleProjectChange = (data: any) => {
        const { value, label } = data;
        setSelectedProjectOptionDropDown({ value: value, label: label });
        dispatch(setOptionProjectValue({ value: value, label: label }));
        fetchTaskData(1, "", value);
        setSelectedTaskOptionDropDown({ value: '0', label: 'All' });
    }

    const handleTaskChange = (data: any) => {
        const { value, label } = data;
        setSelectedTaskOptionDropDown({ value: value, label: label });
        dispatch(setOptionTaskValue({ value: value, label: label }));
    }

    const handleBilledChange = (data: any) => {
        const { value, label } = data;
        setSelectedBilledOptionDropDown({ value: value, label: label });
        dispatch(setOptionBilledValue({ value: value, label: label }));
    }

    const handleApplyFilterOnClickEvent = () => {
        if (closeButtonRef.current) {
            closeButtonRef.current.click();
        }
        let SearchParamsValues = `${selectedClientNameOptionDropDown.value},${selectedProjectOptionDropDown.value},${selectedTaskOptionDropDown.value},${selectedBilledOptionDropDown.value},false,${moment(SelectedStartDate).format(dateInsertionFormat)},${moment(SelectedEndDate).format(dateInsertionFormat)},${selectedClientNameOptionDropDown.label},${selectedProjectOptionDropDown.label},${selectedTaskOptionDropDown.label}`;
        dispatch(getTimeBilingWorksheetForDatatableAsync({ currentPage: 1, pageSize: pageSize, start: start, SearchParamsValues: SearchParamsValues, search: "" }));
    }

    const handleResetFiltersOnClickEvent = () => {
        const SDate = new Date();
        const EDate = new Date();
        setSelectedStartDate(SDate);
        setSelectedEndDate(EDate);
        if (closeButtonRef.current) {
            closeButtonRef.current.click();
        }
    }

    const handleClientChange = (selected: any) => {
        setSelectedClientNameOptionDropDown(selected);
        const { value, label } = selected;
        dispatch(setOptionClientNameValue({ value: value, label: label }));
        fetchProjectData(1, "", value);
        // getProjectAsync(value);
        setSelectedProjectOptionDropDown({ value: '0', label: 'All' });
        setSelectedTaskOptionDropDown({ value: '0', label: 'All' });
    }

    const handleClientInputChange = (inputValue: string) => {
        setSearch(inputValue);
    }

    const handleProjectInputChange = (inputValue: string) => {
        setSearchProject(inputValue);
    }

    const handleTaskInputChange = (inputValue: string) => {
        setSearchTask(inputValue);
    }

    return (
        <>
            <div className='card-body'>
                <div className='row' >
                    <div className='col-md-12'>
                        <label className="fs-7 fs-7 fw-normal mb-2">
                            {/* {t('Date Range')} */}
                            {getValueFromResource('Date Range',dispatch, t)}
                            </label>
                        <div>
                            <DateRangePicker
                                onChange={handleDateRangeChange}
                                ranges={DatePickerRanges() }
                                value={[SelectedStartDate, SelectedEndDate]}
                                //placeholder='Please Select Date Range'
                                placeholder={displayedRange}
                                cleanable={false}
                                character={' - '}
                                placement="bottomEnd"
                                format={normalizeDateFormat(CurrentCultureDateFormat.toString())}
                            ></DateRangePicker>
                        </div>
                    </div>
                </div>
                <div className='row mt-6'>
                    <div className='col-md-12'>
                        <label className="fs-7 fs-7 fw-normal mb-2">
                            {/* {t('Client Name')} */}
                            {getValueFromResource('Client Name',dispatch, t)}
                            </label>
                        <div>
                            <Select
                                value={selectedClientNameOptionDropDown}
                                className="basic-single"
                                classNamePrefix="select"
                                isSearchable={true}
                                name="StatusList"
                                onChange={handleClientChange}
                                options={clientdata}
                                styles={dropDownSelectionStyles}
                                maxMenuHeight={maxMenuHeight}
                                onInputChange={handleClientInputChange}
                                components={{ MenuList: customMenuListClient }}
                            />
                        </div>
                    </div>
                </div>
                <div className='row mt-6'>
                    <div className='col-md-12'>
                        <label className="fs-7 fs-7 fw-normal mb-2">
                            {/* {t('Project')} */}
                            {getValueFromResource('Project',dispatch, t)}
                            </label>
                        <div>
                            <Select
                                value={selectedProjectOptionDropDown}
                                className="basic-single"
                                classNamePrefix="select"
                                isSearchable={true}
                                name="StatusList"
                                onChange={handleProjectChange}
                                options={projectdata}
                                styles={dropDownSelectionStyles}
                                maxMenuHeight={maxMenuHeight}
                                onInputChange={handleProjectInputChange}
                                components={{ MenuList: customMenuProjectClient }}
                            />
                        </div>
                    </div>
                </div>
                <div className='row mt-6'>
                    <div className='col-md-12'>
                        <label className="fs-7 fs-7 fw-normal mb-2">
                            {/* {t('Project Tasks')} */}
                            {getValueFromResource('Project Tasks',dispatch, t)}
                            </label>
                        <div>
                            <Select
                                value={selectedTaskOptionDropDown}
                                className="basic-single"
                                classNamePrefix="select"
                                isSearchable={true}
                                name="StatusList"
                                onChange={handleTaskChange}
                                options={taskdata}
                                styles={dropDownSelectionStyles}
                                maxMenuHeight={maxMenuHeight}
                                onInputChange={handleTaskInputChange}
                                components={{ MenuList: customMenuTaskClient }}
                            />
                        </div>
                    </div>
                </div>
                <div className='row mt-6'>
                    <div className='col-md-12'>
                        <label className="fs-7 fs-7 fw-normal mb-2">
                            {/* {t('Billed')} */}
                            {getValueFromResource('Billed',dispatch, t)}
                            </label>
                        <div>
                            <Select
                                value={selectedBilledOptionDropDown}
                                className="basic-single"
                                classNamePrefix="select"
                                isSearchable={true}
                                name="BilledList"
                                onChange={handleBilledChange}
                                options={BilledArray}
                                styles={dropDownSelectionStyles}
                                maxMenuHeight={maxMenuHeight}
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div className='card-footer pt-4 '>
                <div className='d-flex flex-stack float-end'>
                    <button
                        type="button"
                        className="btn btn-secondary btn-sm me-2"
                        data-kt-element='send'
                        onClick={handleResetFiltersOnClickEvent}
                    >
                        {/* {t('Cancel')} */}
                        {getValueFromResource('Reset Filters',dispatch, t)}
                    </button>
                    <button
                    ref={closeButtonRef}
                        type="button"
                        data-kt-element='send'
                        id='kt_OffCanvas_close'
                        className="btn btn-primary btn-sm fs-7"
                        onClick={handleApplyFilterOnClickEvent}
                    >                          
                      <i className="bi bi-filter fs-5 me-1"></i>
                        {/* {t('Apply Filters')} */}
                        {getValueFromResource('Apply Filters',dispatch, t)}
                    </button>
                </div>
            </div>
        </>
    )
}

export default TimeBillingWorksheetFilter